export default __webpack_public_path__ + "static/media/Dental_Plan_All_Brochure.2449fb3b.pdf";